import { conversationQuery } from "@/api/mgmtMessages";
import { queryClient } from "@/api/utils";
import { SplitPageContent } from "@/components/ui/PageWrapper";
import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { number, object, optional } from "valibot";

export const Route = createFileRoute("/supplier/$supplierId/messages/$conversationId")({
  component: lazyRouteComponent(() => import("./+Conversation")),
  validateSearch: object({
    call: optional(number()),
  }),
  head: async ({ params }) => {
    const conversation = await queryClient.ensureQueryData(conversationQuery(params.supplierId, params.conversationId));

    return {
      meta: seo({ title: conversation?.member_name || "Chat" }),
    };
  },
  pendingComponent: () => <SplitPageContent />,
});
